import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function ValiantLiquidityTriggerFullDetails({ trigger }: Props) {
  const executedWhenDisplay = (
    <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center tw:flex-wrap">
      <Text as="span" variant="body-sm" color="muted">
        User provides liquidity on
      </Text>
      <Badge size="sm">Valiant</Badge>
    </div>
  );

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Volume Expression" value={trigger.volumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Expression" value={trigger.revenueExpression ?? '-'} />
      <KeyValueRow label="Volume Currency" value={trigger.currencyVolumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Currency" value={trigger.currencyRevenueExpression ?? '-'} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
